import { render, staticRenderFns } from "./PurcharseOrder.vue?vue&type=template&id=46d112d0&"
import script from "./PurcharseOrder.vue?vue&type=script&lang=js&"
export * from "./PurcharseOrder.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports